import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu } from "@headlessui/react";
import iconAngleDown from "assets/images/icons/icon-angle-down.svg";
import { Link } from "react-router-dom";

const SortBy = ({title, firstOption, options}) => {
    let showActiveIndicator = false;
    options.map((option) => {
        if (option.active === true){
            showActiveIndicator = true;
        }
        return null;
    })

    return ( 
        <div className="flex">
            <div className="mr-2 my-auto whitespace-nowrap">
                {title || "Sort By"}
            </div>
            
            <Menu as="div">
                <Menu.Button as="div" className="h-full btn px-3 text-sm border border-gray-300 cursor-pointer whitespace-nowrap">
                    <span>{firstOption || "Most Recent"}</span>
                    <img src={iconAngleDown} alt="arrow" className="h-5 m-auto object-contain" />
                </Menu.Button>
                <Menu.Items className="dropdown">
                    {options.map(({title, link, active}) => (
                        <Menu.Item key={link}>
                            <Link to={link} className="dropdown-item flex">
                                {showActiveIndicator && 
                                    <div className="w-6">
                                        {active && <FontAwesomeIcon icon="check" className="mt-0.5" />}
                                    </div>
                                }
                                {title}
                            </Link>
                        </Menu.Item>
                        ))}
                    {/* <Menu.Item>
                        <div onClick={() => {return null}} className="dropdown-item flex">
                            Oldest
                        </div>
                    </Menu.Item>
                    <Menu.Item>
                        <div onClick={() => {return null}} className="dropdown-item flex">
                            Aplhabetically
                        </div>
                    </Menu.Item> */}
                </Menu.Items>
            </Menu>
        </div>
    )
}

export default SortBy;